import React from "react";
import ServicesCard from "../components/servicesCard";

function Search() {
  const ServicesCardData = [
    {
      title: "Horoscope",
      image: "/images/service1.svg",
    },
    {
      title: "Astrology",
      image: "/images/service2.svg",
    },
    {
      title: "Kundli",
      image: "/images/service3.svg",
    },
    {
      title: "Kundli Matching",
      image: "/images/service4.svg",
    },
    {
      title: "Consultation",
      image: "/images/service5.svg",
    },
  ];
  return (
    <>
      <section className="search-bg py-8 md:py-12">
        <div className="container">
          <div className="search-box relative mb-4">
            <button className="absolute top-[15px] left-[10px]">
              <img src="/images/search.svg" alt="search" />
            </button>
            <input
              type="text"
              className="custom-input !pl-[45px]"
              placeholder="Search here"
            />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[15px] md:gap-[30px]">
            {ServicesCardData.map((item, index) => (
              <ServicesCard key={index} title={item.title} image={item.image} />
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

export default Search;
